import React, { useEffect, useState } from 'react';

/**
 * Renders a Google Maps Heatmap layer using competitor locations.
 * Requires the 'visualization' library to be loaded via useJsApiLoader.
 */
const CompetitorHeatmapLayer = ({ map, gasStations = {}, cStores = {} }) => {
  const [heatmap, setHeatmap] = useState(null);

  useEffect(() => {
    if (!map || !window.google?.maps?.visualization) return;

    // Flatten and collect lat/lng from all radius buckets
    const flatten = (bucket) => {
      if (Array.isArray(bucket)) return bucket;
      if (typeof bucket === 'object' && bucket !== null) return Object.values(bucket).flat();
      return [];
    };

    const allPlaces = [...flatten(gasStations), ...flatten(cStores)];
    const points = allPlaces
      .filter(p => p.latitude != null && p.longitude != null)
      .map(p => ({
        location: new window.google.maps.LatLng(Number(p.latitude), Number(p.longitude)),
        weight: p.user_ratings_total ? Math.min(p.user_ratings_total / 50, 5) : 1,
      }));

    if (points.length === 0) return;

    const layer = new window.google.maps.visualization.HeatmapLayer({
      data: points,
      map,
      radius: 60,
      opacity: 0.45,
      gradient: [
        'rgba(0, 255, 0, 0)',
        'rgba(0, 255, 0, 0.4)',
        'rgba(255, 255, 0, 0.5)',
        'rgba(255, 165, 0, 0.6)',
        'rgba(255, 69, 0, 0.7)',
        'rgba(255, 0, 0, 0.8)',
      ],
    });

    setHeatmap(layer);

    return () => {
      layer.setMap(null);
    };
  }, [map, gasStations, cStores]);

  // Keep heatmap in sync with visibility (handled by parent toggling this component)
  useEffect(() => {
    return () => {
      if (heatmap) heatmap.setMap(null);
    };
  }, [heatmap]);

  return null; // Pure imperative — no JSX rendered
};

export default CompetitorHeatmapLayer;
